import React, { useEffect, useState } from "react";
import { Button } from "./ui/button.jsx";
import { useI18n } from "../i18n/I18nContext";

const CONSENT_KEY = "imago_cookie_consent";

function applyConsent(value) {
  if (typeof window === "undefined") return;
  if (value === "accepted") {
    window.gtag?.("consent", "update", {
      analytics_storage: "granted",
    });
    window.posthog?.opt_in_capturing();
  } else {
    window.gtag?.("consent", "update", {
      analytics_storage: "denied",
    });
    window.posthog?.opt_out_capturing();
  }
}

export default function CookieBanner() {
  const { t } = useI18n();
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const stored = localStorage.getItem(CONSENT_KEY);
    if (!stored) {
      setVisible(true);
    } else {
      applyConsent(stored);
    }
  }, []);

  function handleAccept() {
    localStorage.setItem(CONSENT_KEY, "accepted");
    applyConsent("accepted");
    setVisible(false);
  }

  function handleDecline() {
    localStorage.setItem(CONSENT_KEY, "declined");
    applyConsent("declined");
    setVisible(false);
  }

  if (!visible) return null;

  return (
    <div
      role="dialog"
      aria-label={t("Cookie consent")}
      className="fixed bottom-0 left-0 right-0 z-50 border-t border-white/10 bg-[#05060d]/95 px-6 py-5 shadow-2xl backdrop-blur-md"
    >
      <div className="mx-auto flex max-w-7xl flex-col gap-4 sm:flex-row sm:items-center sm:justify-between">
        <p className="text-sm text-white/70 sm:max-w-2xl">
          {t("We use cookies and similar technologies to analyze site traffic and improve your experience.")}{" "}
          {t("By clicking Accept All, you consent to our use of analytics cookies (Google Analytics, PostHog).")}{" "}
          {t("You can also")}{" "}
          <a href="/privacy" className="underline underline-offset-2 hover:text-white transition-colors">
            {t("read our Privacy & Cookie Policy")}
          </a>
          .
        </p>
        <div className="flex shrink-0 gap-3">
          <Button
            variant="outline"
            size="sm"
            onClick={handleDecline}
            className="border-white/20 text-white/70 hover:bg-white/10 hover:text-white"
          >
            {t("Decline")}
          </Button>
          <Button
            size="sm"
            onClick={handleAccept}
            className="bg-accent text-white hover:bg-accent/90"
          >
            {t("Accept All")}
          </Button>
        </div>
      </div>
    </div>
  );
}
